import React, {useEffect, useState} from 'react';

import {createStyles, withStyles, WithStyles,} from '@material-ui/core/styles';

import locales from '../../../locales';
import {TRestaurant} from '../../../types/ICabinetStore';
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {ReactComponent as Magic} from '../../../images/magic.svg'
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel/index";
import Select from "@material-ui/core/Select/index";
import {Backdrop, Fade, InputBase, MenuItem, Modal, Theme} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
    ExtraCatalogResponse,
    KitchenType,
    RestaurantType
} from "../../../api";
import EstablishmentCatalog from "./EstablishmentCatalog";
import KitchenCatalog from "./KitchenCatalog";
import Wishes from "./Wishes";
import BlurChangeTextField from "../../Common/Fields/BlurChangeTextField";
import {cardFieldType, getPhoneCodes} from "../../../config/constants";
import {getCodePhoneNumber, onlyNumbers} from "../../../helpers/reserveHelpers";
import TitleNew from "../../Common/TitleNew";
import BlurChangeTextArea from "../../Common/Fields/BlurChangeTextArea";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";


const styles = (theme: Theme) => createStyles({
    restaurantCard: {
        backgroundColor: '#fff',
    },
    contentWrap: {
        padding: '0 20px 20px 20px',
        [theme.breakpoints.down(600)]: {
            paddingInline: 0
          },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#0a192338',
            },
        },
        '& .MuiSelect-icon': {
            marginRight: '16px'
        }
    },
    descriptionContainer: {
        position: 'relative'
    },
    description: {
        resize: 'vertical',
        width: '100%',
        borderColor: 'rgba(10, 25, 35, 0.22)',
        borderRadius: '4px',
        backgroundColor: '#fff',
        fontFamily: 'GolosTextWebRegular Roboto',
        fontSize: '15px',
        lineHeight: '24px',
        letterSpacing: '-0.15px',
        padding: '9px 34px 9px 16px',
        "&:focus": {
            outline: "none",
            borderColor: 'rgba(10, 25, 35, 0.9)',
        },
    },
    alert: {
        backgroundColor: '#D9F2FF',
        borderRadius: '6px',
        padding: '20px',
        color: '#16B1FF',
    },
    alertTitle: {
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '28px'
    },
    alertText: {
        fontSize: '13px',
        fontWeight: 400,
        lineHeight: '16px',
        marginTop: '16px',
        marginBottom: '24px'
    },
    btn: {
        width: '100px',
        height: '36px',
        borderRadius: 6,
        background: '#16B1FF',
        color: '#fff',
        '&:hover': {
            background: '#16B1FF',
        },
    },
    formControl: {
        minWidth: 150,
    },
    block: {
        margin: '20px 0px'
    },
    phone: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    code: {
        marginRight: '20px',
    },
    phoneInput: {
        marginLeft: '20px',
    },
    iconColor: {
        color: '#149FE6'
    },
    subtitle: {
        lineHeight: '30px',
        marginTop: '30px',
        marginBottom: '21px'
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '6px'
    },
    paper: {
        width: '600px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        border: '2px solid #000',
        boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);',
        padding: '16px 32px 24px',
    },
    modalTitle: {
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: '28px',
        letterSpacing: '-0.5px',
        marginBottom: '20px'
    },
    modalBtnCancel: {
        borderColor: '#8A8D93',
        color: '#8A8D93',
        '&:hover': {
            borderColor: '#8A8D93',
        }
    },
    modalBtnAccept: {
        color: '#fff',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#6AE8C5',
            boxShadow: 'none',
        },
    },
    loader: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        display: 'inline-block',
        margin: '6px auto',
        position: 'relative',
        color: '#fff',
        boxSizing: 'border-box',
        animation: '$animloader 2s linear infinite',
    },
    '@keyframes animloader': {
        '0%': {
            boxShadow: '14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px',
        },
        '25%': {
            boxShadow: '14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 2px',
        },
        '50%': {
            boxShadow: '14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 2px, -38px 0 0 -2px',
        },
        '75%': {
            boxShadow: '14px 0 0 2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px',
        },
        '100%': {
            boxShadow: '14px 0 0 -2px, 38px 0 0 2px, -14px 0 0 -2px, -38px 0 0 -2px',
        },
    },
});

interface IProps extends WithStyles<typeof styles>{
    currentRestaurant: TRestaurant;
    scrapeInfoLoading: boolean;
    updateRestaurant: (info: {
        value: string | number | boolean | Array<string>, type: any
    }) => void;
    restaurantInfoScrape: () => void,
    establishmentCatalog: RestaurantType[],
    kitchenCatalog: KitchenType[],
    extraCatalog: ExtraCatalogResponse[]
}

const Index: React.FC<IProps> = ({
    classes,
    currentRestaurant,
    scrapeInfoLoading,
    updateRestaurant,
    restaurantInfoScrape,
    establishmentCatalog,
    kitchenCatalog,
    extraCatalog
}) => {
    const [phoneLocalNumber, setPhoneLocalNumber] = useState<string>('')
    const [phoneCountryCode, setPhoneCountryCode] = useState<string>('')
    const [kitchens, setKitchens] = useState<Array<string>>([])
    const [establishments, setEstablishments] = useState<Array<string>>([])
    const [extras, setExtras] = useState<Array<string>>([])
    let firstCountryKey: undefined | string = 'ru';

    useEffect(() => {
        if (currentRestaurant) {
            const phoneNumbers = currentRestaurant.info.phone ? onlyNumbers(currentRestaurant.info.phone) : null
            if (phoneNumbers) {
                const codeAndNumber = getCodePhoneNumber(phoneNumbers)
                setPhoneCountryCode(codeAndNumber.code)
                setPhoneLocalNumber(codeAndNumber.number)
            } else {
                setPhoneCountryCode('+7')
            }
            const restaurantKitchens = currentRestaurant.kitchens
            if (restaurantKitchens && Array.isArray(restaurantKitchens) && restaurantKitchens.length > 0) {
                setKitchens(currentRestaurant.kitchens)
            }

            const restaurantEstablishments = currentRestaurant.establishments
            if (restaurantEstablishments && Array.isArray(restaurantEstablishments) && restaurantEstablishments.length> 0) {
                setEstablishments(currentRestaurant.establishments)
            }

            const restaurantExtras = currentRestaurant.extras
            if (restaurantExtras && Array.isArray(restaurantExtras) && restaurantExtras.length > 0) {
                setExtras(currentRestaurant.extras)
            }
        }
    }, [currentRestaurant])

    const onCountryCodeChange = (countryCode: string) => {
        setPhoneCountryCode(countryCode)
        setPhoneLocalNumber('')
    }


    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const validatePhone = (value: string): boolean => {
        if (value.length === 0) {
            return true
        }
        return !!value && /^[\d\s]+$/.test(value);
    }

    const BootstrapInput = withStyles((theme) => ({
        input: {
            borderRadius: 4,
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            border: '1px solid #ced4da',
            fontSize: 16,
            padding: '9px 26px 9px 12px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            '&:focus': {
                borderRadius: 4,
                borderColor: '#80bdff',
                boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
            },
        },
    }))(InputBase);
    return (
    <div className={classes.restaurantCard}>
        <div className={classes.contentWrap}>
            <TitleNew text={locales.t('reservesSystem.restaurantCard.title')} />
            <div className={classes.alert}>
                <Typography className={classes.alertTitle}>
                    { locales.t('reservesSystem.restaurantCard.alertTitle') }
                </Typography>
                <Typography className={classes.alertText}>
                    { locales.t('reservesSystem.restaurantCard.alertText') }
                </Typography>
                <Button
                    startIcon={!scrapeInfoLoading && <Magic/>}
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.btn}
                    onClick={!scrapeInfoLoading ? handleOpen : undefined}
                >
                    {scrapeInfoLoading ? (<span className={classes.loader}></span>) :
                        locales.t('reservesSystem.restaurantCard.alertBtnText')
                    }

                </Button>
            </div>

            <div className={classes.block}>
                <span style={scrapeInfoLoading ? {color: 'rgba(10, 25, 35, 0.4)'} : { color: 'rgba(10, 25, 35, 0.9)'}}>{locales.t('reservesSystem.restaurantCard.phone')}</span>
                <div className={classes.phone}>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-customized-select-label"></InputLabel>
                        <Select
                            disabled={scrapeInfoLoading}
                            labelId="demo-customized-select-label"
                            id="demo-customized-select"
                            value={phoneCountryCode}
                            IconComponent={(props) =>
                                props.open ? <ExpandLess {...props} /> : <ExpandMore {...props} />
                            }
                            input={<BootstrapInput />}
                            onChange={(e: any) => onCountryCodeChange(e.target.value)}
                        >
                            {getPhoneCodes(firstCountryKey, true).map(phoneCode => (
                                <MenuItem value={phoneCode.code} key={phoneCode.key}>
                                    { `${(phoneCode.key).toUpperCase()} (${phoneCode.code})` }
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <BlurChangeTextField
                        disabled={scrapeInfoLoading}
                        validate={validatePhone}
                        className={classes.phoneInput}
                        fullWidth
                        id="outlined-basic"
                        variant="outlined"
                        size='small'
                        value={phoneLocalNumber}
                        onChange={(value:any) => {
                            setPhoneLocalNumber(value)
                            const phoneNumber = `${phoneCountryCode}${onlyNumbers(value)}`
                            updateRestaurant({
                                value: phoneNumber,
                                type: cardFieldType.phone
                            })
                        }}
                    />
                </div>
            </div>
            <div className={classes.block}>
                <BlurChangeTextField
                    fullWidth
                    id="outlined-basic"
                    variant="outlined"
                    size='small'
                    label={locales.t('reservesSystem.restaurantCard.site')}
                    disabled={scrapeInfoLoading}
                    value={currentRestaurant.info.site ? currentRestaurant.info.site : ''}
                    onChange={(value) => {
                        updateRestaurant({
                            value, type: cardFieldType.site
                        })
                    }}
                />
            </div>
            <div className={classes.block}>
                <BlurChangeTextField
                    fullWidth
                    id="outlined-basic"
                    variant="outlined"
                    size='small'
                    label={locales.t('reservesSystem.restaurantCard.vk')}
                    disabled={scrapeInfoLoading}
                    value={currentRestaurant.info.vk ? currentRestaurant.info.vk : ''}
                    onChange={(value) => {
                        updateRestaurant({
                            value, type: cardFieldType.vk
                        })
                    }}
                />
            </div>
            <div className={classes.block}>
                <BlurChangeTextField
                    fullWidth
                    id="outlined-basic"
                    variant="outlined"
                    size='small'
                    label={locales.t('reservesSystem.restaurantCard.telegram')}
                    disabled={scrapeInfoLoading}
                    value={currentRestaurant.info.telegram ? currentRestaurant.info.telegram : ''}
                    onChange={(value) => {
                        updateRestaurant({
                            value, type: cardFieldType.telegram
                        })
                    }}
                />
            </div>
            <BlurChangeTextArea
                label={locales.t('reservesSystem.restaurantCard.description')}
                className={classes.description}
                rowsMin={3}
                placeholder=""
                maxLength={1000}
                disabled={scrapeInfoLoading}
                value={currentRestaurant.description ? currentRestaurant.description : ''}
                onChange={(value) => {
                    updateRestaurant({
                        value, type: cardFieldType.description
                    })
                }}
            />
            <div>
                <Typography variant="h6" className={classes.subtitle}>Категоризация</Typography>
                <EstablishmentCatalog
                    disabled={scrapeInfoLoading}
                    chosenTypes={establishments}
                    restaurantTypes={establishmentCatalog}
                    onChange={
                        (value: string[]) => {
                            updateRestaurant({ value, type: cardFieldType.establishments })
                        }
                    }
                />
                <KitchenCatalog
                    disabled={scrapeInfoLoading}
                    chosenTypes={kitchens}
                    kitchenTypes={kitchenCatalog}
                    onChange={(value: string[]) => {
                        updateRestaurant({ value, type: cardFieldType.kitchen })
                    }
                }/>
                <Wishes
                    disabled={scrapeInfoLoading}
                    chosenTypes={extras}
                    extraTypes={extraCatalog}
                    onChange={
                        (value: string[]) => {
                            updateRestaurant({ value, type: cardFieldType.extras })
                        }
                    }
                />
            </div>
        </div>
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className={classes.modalTitle} id="transition-modal-title">Получить данные с помощью ИИ</div>
                    <div id="transition-modal-description">Наш искусственный интеллект соберёт данные о вашем ресторане
                        из открытых источников.</div>
                    <div>Все поля будут заполнены автоматически. Текущая информация
                        будет обновлена.</div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: '20px',
                        gap: '10px'
                    }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            className={classes.modalBtnCancel}
                            onClick={handleClose}
                        >
                            Отмена
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.modalBtnAccept}
                            onClick={() => {
                                restaurantInfoScrape();
                                handleClose();
                            }}
                        >
                            Обновить
                        </Button>
                    </div>
                </div>
            </Fade>
        </Modal>
    </div>
)};

export default withStyles(styles)(Index);
